import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { 
  Shield, 
  ArrowLeft,
  Building2,
  Globe,
  Server,
  Scale,
  Mail,
  FileText
} from "lucide-react";

const LegalPage = () => {
  const currentDate = "Mai 2026";

  return (
    <div className="min-h-screen bg-[#FFF0F5]">
      {/* Header */}
      <header className="sticky top-0 z-50 w-full bg-white/80 backdrop-blur-md border-b border-pink-100">
        <div className="container mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 font-extrabold text-xl" style={{ fontFamily: 'Outfit' }}>
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-pink-200 to-pink-100 flex items-center justify-center">
              <Shield size={18} className="text-[#FF3366]" fill="#FF3366" />
            </div>
            <span className="text-slate-900">RATESHARE</span>
          </Link>
          <Link to="/">
            <Button variant="ghost" className="rounded-full">
              <ArrowLeft size={18} className="mr-2" />
              Retour
            </Button>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="space-y-8">
          {/* Title */}
          <div className="text-center space-y-4">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#FF3366]/10 text-[#FF3366] text-sm font-medium">
              <Scale size={16} />
              Informations légales
            </div>
            <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900" style={{ fontFamily: 'Outfit' }}>
              Mentions Légales
            </h1>
            <p className="text-slate-500">Dernière mise à jour : {currentDate}</p>
          </div>

          {/* Éditeur */}
          <section className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#FF3366]/10 flex items-center justify-center">
                <Building2 className="text-[#FF3366]" size={20} />
              </div>
              <h2 className="text-xl font-bold text-slate-900">1. Éditeur du site</h2>
            </div>
            <Card className="guardian-card">
              <CardContent className="p-6">
                <div className="bg-slate-50 p-5 rounded-xl border border-slate-100">
                  <p className="font-bold text-slate-900 text-lg">SAS RATESHARE</p>
                  <p className="text-slate-500 text-sm mt-1">Société par Actions Simplifiée</p>
                  
                  <div className="mt-4 space-y-2 text-sm text-slate-600">
                    <p><span className="font-medium text-slate-700">Siège social :</span> Lyon, France</p>
                    <p><span className="font-medium text-slate-700">Président & CEO :</span> Samy Cherif</p>
                    <p><span className="font-medium text-slate-700">Délégué à la Protection des Données (DPO) :</span> Samy Cherif</p>
                  </div>
                  
                  <div className="mt-4 pt-4 border-t border-slate-200">
                    <p className="text-sm text-slate-600">
                      <span className="font-medium text-slate-700">Contact :</span>{" "}
                      <a href="mailto:contact@rateshare.fr" className="text-[#FF3366] hover:underline">
                        contact@rateshare.fr
                      </a>
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </section>

          {/* Directeur de publication */}
          <section className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#FF3366]/10 flex items-center justify-center">
                <FileText className="text-[#FF3366]" size={20} />
              </div>
              <h2 className="text-xl font-bold text-slate-900">2. Directeur de la publication</h2>
            </div>
            <Card className="guardian-card">
              <CardContent className="p-6">
                <p className="text-slate-600">
                  <span className="font-medium text-slate-900">Samy Cherif</span>, en qualité de Président de la SAS RATESHARE.
                </p>
              </CardContent>
            </Card>
          </section>

          {/* Hébergement */}
          <section className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#FF3366]/10 flex items-center justify-center">
                <Server className="text-[#FF3366]" size={20} />
              </div>
              <h2 className="text-xl font-bold text-slate-900">3. Hébergement</h2>
            </div>
            <Card className="guardian-card">
              <CardContent className="p-6">
                <p className="text-slate-600 mb-4">
                  Le site et l'application RATESHARE sont hébergés par :
                </p>
                <div className="bg-green-50 p-4 rounded-xl border border-green-200">
                  <p className="font-bold text-green-800">OVH SAS</p>
                  <p className="text-green-700 text-sm mt-1">
                    2 rue Kellermann, 59100 Roubaix, France<br />
                    Téléphone : +33 9 72 10 10 07
                  </p>
                  <div className="mt-3 inline-flex items-center gap-2 px-3 py-1 rounded-full bg-green-100 text-green-700 text-xs font-medium">
                    <Globe size={12} />
                    Données hébergées en France
                  </div>
                </div>
              </CardContent>
            </Card>
          </section>

          {/* Propriété intellectuelle */}
          <section className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#FF3366]/10 flex items-center justify-center">
                <Shield className="text-[#FF3366]" size={20} />
              </div>
              <h2 className="text-xl font-bold text-slate-900">4. Propriété intellectuelle</h2>
            </div>
            <Card className="guardian-card">
              <CardContent className="p-6 space-y-4">
                <p className="text-slate-600">
                  L'ensemble du contenu du site RATESHARE (textes, graphismes, images, logos, icônes, logiciels, base de données) 
                  est la propriété exclusive de SAS RATESHARE ou de ses partenaires et est protégé par les lois françaises 
                  et internationales relatives à la propriété intellectuelle.
                </p>
                <p className="text-slate-600">
                  Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site, 
                  quel que soit le moyen ou le procédé utilisé, est interdite sans l'autorisation écrite préalable de SAS RATESHARE.
                </p>
                <p className="text-slate-600">
                  La marque RATESHARE, ainsi que le logo associé, sont des marques déposées. Toute utilisation non autorisée 
                  constitue une contrefaçon passible de sanctions pénales.
                </p>
              </CardContent>
            </Card>
          </section>

          {/* Protection des données */}
          <section className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#FF3366]/10 flex items-center justify-center">
                <Scale className="text-[#FF3366]" size={20} />
              </div>
              <h2 className="text-xl font-bold text-slate-900">5. Protection des données personnelles</h2>
            </div>
            <Card className="guardian-card">
              <CardContent className="p-6 space-y-4">
                <p className="text-slate-600">
                  Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, 
                  vous disposez d'un droit d'accès, de rectification, d'effacement et de portabilité de vos données personnelles.
                </p>
                <p className="text-slate-600">
                  Pour exercer ces droits ou pour toute question relative à la protection de vos données, vous pouvez contacter 
                  notre Délégué à la Protection des Données (DPO) :
                </p>
                <div className="bg-slate-50 p-4 rounded-xl border border-slate-100">
                  <p className="font-medium text-slate-900">Samy Cherif - DPO</p>
                  <p className="text-slate-600 text-sm mt-1">
                    <a href="mailto:contact@rateshare.fr" className="text-[#FF3366] hover:underline">contact@rateshare.fr</a>
                  </p>
                </div>
                <p className="text-slate-500 text-sm">
                  Pour plus d'informations, consultez notre{" "}
                  <Link to="/privacy" className="text-[#FF3366] hover:underline">Politique de Confidentialité</Link>.
                </p>
              </CardContent>
            </Card>
          </section>

          {/* Contact */}
          <section className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#FF3366]/10 flex items-center justify-center">
                <Mail className="text-[#FF3366]" size={20} />
              </div>
              <h2 className="text-xl font-bold text-slate-900">6. Contact</h2>
            </div>
            <Card className="guardian-card">
              <CardContent className="p-6">
                <p className="text-slate-600 mb-4">
                  Pour toute question concernant ces mentions légales ou le fonctionnement du site :
                </p>
                <a 
                  href="mailto:contact@rateshare.fr"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-[#FF3366] text-white rounded-full font-semibold hover:bg-[#E62E5C] transition-colors"
                >
                  <Mail size={18} />
                  contact@rateshare.fr
                </a>
              </CardContent>
            </Card>
          </section>
        </div>

        {/* Footer */}
        <footer className="mt-16 pt-8 border-t border-pink-200 text-center text-slate-500 text-sm">
          <p>© 2026 SAS RATESHARE. Tous droits réservés.</p>
          <div className="flex justify-center gap-6 mt-4">
            <Link to="/terms" className="hover:text-[#FF3366] transition-colors">CGU</Link>
            <Link to="/privacy" className="hover:text-[#FF3366] transition-colors">Confidentialité</Link>
            <Link to="/" className="hover:text-[#FF3366] transition-colors">Accueil</Link>
          </div>
        </footer>
      </main>
    </div>
  );
};

export default LegalPage;
